import { i18n } from "@/locales/index.js";

export default async ({ from, to, next }) => {
  if(to.matched.find(matched => matched.name === 'Default')) {
    if(to.params.locale) {
      i18n.locale = to.params.locale;
      return next();
    }
    else {
      return next()
    }
  } else {
    return next();
  }
}


// WEBPACK FOOTER //
// ./src/router/middleware/lang.js